import { useState } from 'react';
import { useI18n } from '../i18n';
import Button from '../components/Button';

export default function Contact() {
  const { t } = useI18n();
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
  }

  return (
    <section id="contact" className="bg-[#0F172A] px-6 py-24 text-[#FFFBEB]">
      <div className="mx-auto max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="font-['Russo_One'] text-4xl uppercase text-[#F59E0B] md:text-5xl">
            {t('contact.title')}
          </h2>
          <p className="mt-4 text-lg text-[#FDE68A]/90">{t('contact.subtitle')}</p>
        </div>

        {submitted ? (
          <div className="border-2 border-[#F59E0B] bg-[#F59E0B]/10 p-8 text-center">
            <p className="text-xl font-semibold text-[#F59E0B]">{t('contact.success')}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid gap-6 sm:grid-cols-2">
              <div>
                <label htmlFor="name" className="mb-2 block text-sm font-semibold uppercase tracking-wider text-[#FDE68A]">
                  {t('contact.name')}
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  className="w-full border-2 border-[#FDE68A]/30 bg-transparent px-4 py-3 text-[#FFFBEB] placeholder-[#FDE68A]/40 focus:border-[#F59E0B] focus:outline-none"
                  placeholder={t('contact.name')}
                />
              </div>
              <div>
                <label htmlFor="email" className="mb-2 block text-sm font-semibold uppercase tracking-wider text-[#FDE68A]">
                  {t('contact.email')}
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="w-full border-2 border-[#FDE68A]/30 bg-transparent px-4 py-3 text-[#FFFBEB] placeholder-[#FDE68A]/40 focus:border-[#F59E0B] focus:outline-none"
                  placeholder={t('contact.email')}
                />
              </div>
            </div>
            <div>
              <label htmlFor="message" className="mb-2 block text-sm font-semibold uppercase tracking-wider text-[#FDE68A]">
                {t('contact.message')}
              </label>
              <textarea
                id="message"
                name="message"
                rows={5}
                required
                className="w-full border-2 border-[#FDE68A]/30 bg-transparent px-4 py-3 text-[#FFFBEB] placeholder-[#FDE68A]/40 focus:border-[#F59E0B] focus:outline-none"
                placeholder={t('contact.message')}
              />
            </div>
            <div className="text-center">
              <Button type="submit" variant="primary">
                {t('contact.send')}
              </Button>
            </div>
          </form>
        )}

        <p className="mt-10 text-center text-[#FDE68A]/70">
          {t('contact.emailLabel')}{' '}
          <a href="mailto:hello@amberbytes.org" className="text-[#F59E0B] underline hover:text-[#FBBF24]">
            hello@amberbytes.org
          </a>
        </p>
      </div>
    </section>
  );
}
